import { render } from "./arrow-back.vue?vue&type=template&id=4a6be336&ts=true"
import script from "./arrow-back.vue?vue&type=script&lang=ts"
export * from "./arrow-back.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__